import React from "react";
import VehicleCard from "../components/VehicleCard";
import VehicleFilters, { defaultFilters } from "../components/VehicleFilters";
import api from "../lib/api";
import { Loader2, SearchX } from "lucide-react";

const Inventory = () => {
  const [filters, setFilters] = React.useState(defaultFilters);
  const [vehicles, setVehicles] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    const params = {};
    Object.entries(filters).forEach(([k, v]) => {
      if (v === "" || v === "Alle" || v === undefined || v === null) return;
      params[k] = v;
    });
    api.get("/vehicles", { params })
      .then((r) => setVehicles(r.data))
      .catch(() => setVehicles([]))
      .finally(() => setLoading(false));
  }, [filters]);

  return (
    <div className="bg-[var(--na-bg)] min-h-screen pt-12 pb-24" data-testid="inventory-page">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 lg:mb-12">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[var(--na-red)] font-semibold mb-3">
            Inventory · Wien
          </p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tighter">
            Unsere Fahrzeuge
          </h1>
          <p className="text-zinc-400 mt-4 max-w-xl">
            Premium Fahrzeuge auf Lager. Alle Inserate sind aktuelle Mock-Daten – Live-Inventory folgt
            durch Anbindung an gebrauchtwagen.at, AutoScout24 und willhaben.
          </p>
        </div>

        <VehicleFilters
          value={filters}
          onChange={setFilters}
          onReset={() => setFilters(defaultFilters)}
        />

        <div className="mt-8 flex items-baseline justify-between">
          <p className="text-sm text-zinc-400" data-testid="inventory-result-count">
            {loading ? "Lade Fahrzeuge…" : `${vehicles.length} ${vehicles.length === 1 ? "Fahrzeug" : "Fahrzeuge"} gefunden`}
          </p>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mt-6">
            {[0, 1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="bg-[#2E2E3C] border border-silver-soft rounded-2xl h-96 animate-pulse" />
            ))}
          </div>
        ) : vehicles.length === 0 ? (
          <div className="bg-[#2E2E3C] border border-silver-soft rounded-2xl p-12 text-center mt-6">
            <SearchX className="w-10 h-10 text-zinc-600 mx-auto mb-4" />
            <h3 className="font-display text-xl font-semibold text-white">Keine Fahrzeuge gefunden</h3>
            <p className="text-zinc-400 mt-2 max-w-md mx-auto">
              Versuchen Sie es mit anderen Filtern oder kontaktieren Sie uns direkt – wir finden Ihr Wunschfahrzeug.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mt-6">
            {vehicles.map((v, i) => <VehicleCard key={v.id} vehicle={v} index={i} />)}
          </div>
        )}
      </section>
    </div>
  );
};

export default Inventory;
